const ViewOrderDetail = (props) => {
    const {item} =props;
    const shippingAmount = Number(item?.shippingAmount || 0);
    const currencySymbol = item?.currencySymbol && item.currencySymbol !== "$" ? item.currencySymbol : "\u20B9";
    const itemSubtotal = item?.itemSubtotal ?? item?.orderAmount ?? item?.totalAmount ?? 0;
    const formatAmount = (value) => {
        const amount = Number(value || 0);
        const formattedAmount = amount % 1 === 0 ? amount : amount.toFixed(2);
        return `${currencySymbol}${formattedAmount}`;
    };
    
        return (
            <div className="order_detail_main">
            <div className="order_detail_wrapper">
                {/* <h4>Order Details</h4> */}
                <div className="order_detail_meta">
                    <div>
                        <span style={{ fontWeight: 'bold' }}>Ordered on </span>
                        <span>
                            {item?.orderDate
                                ? new Date(item?.orderDate).toLocaleDateString('en-GB', {
                                    day: 'numeric',
                                    month: 'long',
                                    year: 'numeric'
                                })
                                : null}
                        </span>
                    </div>
                    <div>
                        <span style={{ fontWeight: 'bold' }}>OrderNo : </span>
                        <span>{item?.orderNo}</span>
                    </div>
                </div>
                <div className="order_all_detail_wrapper mt-3">
                    <div className="order_detail_grid">
                        <div className="order_detail_column">
                                <h6>Shipping Address</h6>
                                <p>{item?.shippingAddress}</p>
                        </div>
                        <div className="order_detail_column">
                                <h6>Payment Methods</h6>
                                <p>{item?.paymentMethod}</p>
                        </div>
                        <div className="order_summary">
                            <h6>Order Summary</h6>
                            <div className="order_summary_detail">
                                <span className="heading_order">Item(s) Subtotal:</span>
                                <span className="answ_order">{formatAmount(itemSubtotal)}</span>
                            </div>
                            <div className="order_summary_detail">
                                <span className="heading_order">Discount:</span>
                                <span className="answ_order">{formatAmount(item?.discount)}</span>
                            </div>
                            <div className="order_summary_detail">
                                <span className="heading_order">Coupon Discount:</span>
                                <span className="answ_order">{formatAmount(item?.couponDiscount)}</span>
                            </div>
                            {Number(item?.extraDiscount || 0) > 0 ? (
                                <div className="order_summary_detail">
                                    <span className="heading_order">Extra Discount:</span>
                                    <span className="answ_order">{formatAmount(item?.extraDiscount)}</span>
                                </div>
                            ) : null}
                            <div className="order_summary_detail">
                                <span className="heading_order">Shipping:</span>
                                <span className="answ_order">
                                    {shippingAmount > 0 ? formatAmount(shippingAmount) : "Free"}
                                </span>
                            </div>
                            <div className="order_summary_detail grand_total">
                                <span className="heading_order">Grand Total:</span>
                                <span className="answ_order">{formatAmount(item?.totalAmount)}</span>
                            </div>
                        </div>
                        <div className="order_summary order_summary_legacy">
                            <h6>Order Summary</h6>
                            <div className="order_summary_detail">
                                <span className="heading_order">Item(s) Subtotal:</span>
                                <span className="answ_order">₹{item?.orderAmount}</span>
                            </div>
                            <div className="order_summary_detail">
                                <span className="heading_order">Shipping</span>
                                <span className="answ_order">
                                    {shippingAmount > 0 ? `â‚¹${shippingAmount}` : "Free"}
                                </span>
                            </div>
                            <div className="order_summary_detail">
                                <span className="heading_order">Grand Total:</span>
                                <span className="answ_order">₹{item?.totalAmount}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        )
    }
    
    export default ViewOrderDetail;
